import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9d1400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "reasons" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reasons_desc" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Eine Online-Immobilienbewertung ist sinnvoll, um ein erstes Gefühl für den Wert einer Immobilie zu bekommen. Mit dem kostenlosen und unverbindlichen Immobilienbewertungs-Rechner von immowelt bekommst du einen ersten Eindruck vom Wertniveau deiner Immobilie. Sie lohnt sich immer, weil Eigentümer mit unserer Immobilienbewertung: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Geld sparen:"),
      /*#__PURE__*/_createTextVNode(" Unsere Wertermittlung ist kostenlos. Ein Sachverständiger verlangt mindestens 0,5 Prozent des Verkaufspreises. ")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Zeit sparen:"),
      /*#__PURE__*/_createTextVNode(" Das Ergebnis liegt binnen weniger Minuten vor.")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Stress sparen:"),
      /*#__PURE__*/_createTextVNode(" Nur wenige Daten und keine zusätzlichen Dokumente nötig.")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Entscheidungen treffen können,"),
      /*#__PURE__*/_createTextVNode(" denn sie erhalten eine realistische Einschätzung des Immobilienwerts. ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_info_box, { title: "Darum lohnt sich unsere kostenlose Online-Immobilienbewertung" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}